import React from "react";
import { List } from "antd-mobile";

import "./style.scss";

function CustomList({ header = "", listItems = [] }) {
  return (
    <List header={header} className="agent-mobile-custom-list">
      {listItems?.map((item, index) => {
        return (
          <List.Item key={"list" + index} {...item}>
            {item.contentRender ? item.contentRender() : ""}
          </List.Item>
        );
      })}
    </List>
  );
}

export default CustomList;
